// extracted by mini-css-extract-plugin
export default {"close-btn":"close-btn--EafF1FYTK8MHEmBJZW7s"};